export const COW = [
  "Aberdeen Angus",
  "Abergele",
  "Abigar",
  "Abondance",
  "Abyssinian Shorthorned Zebu",
  "Aceh",
  "Achham",
  "Adamawa",
  "Adaptaur",
  "Afar",
  "Africangus",
  "Afrikaner",
  "Agerolese",
  "Alambadi",
  "Alatau",
  "Albanian",
  "Albera",
  "Alderney",
  "Alentejana",
  "Aleutian wild cattle",
  "Aliad Dinka",
  "Alistana-Sanabresa",
  "Allmogekor",
  "Alur",
  "American",
  "American Angus",
  "American Beef Friesian",
  "American Brown Swiss",
  "American Milking Devon",
  "American White Park",
  "Amerifax",
  "Amrit Mahal",
  "Amsterdam Island cattle",
  "Anatolian Black",
  "Andalusian Black",
  "Andalusian Blond",
  "Andalusian Grey",
  "Angeln",
  "Angoni",
  "Ankina",
  "Ankole",
  "Ankole-Watusi",
  "Aracena",
  "Arado",
  "Argentine Criollo",
  "Argentine Friesian",
  "Armorican",
  "Arouquesa",
  "Arsi",
  "Asturian Mountain",
  "Asturian Valley",
  "Aubrac",
  "Aulie-Ata",
  "Aure et Saint-Girons",
  "Australian Braford",
  "Australian Brangus",
  "Australian Charbray",
  "Australian Friesian Sahiwal",
  "Australian Lowline",
  "Australian Milking Zebu",
  "Australian Shorthorn",
  "Austrian Simmental",
  "Austrian Yellow",
  "Avétonou",
  "Avileña-Negra Ibérica",
  "Aweil Dinka",
  "Ayrshire",
  "Azaouak",
  "Azebuado",
  "Azerbaijan Zebu",
  "Azores",
  "Bedit",
  "Breed",
  "Bachaur cattle",
  "Baherie cattle",
  "Bakosi cattle",
  "Balancer",
  "Baoule",
  "Bargur cattle",
  "Barrosã",
  "Barzona",
  "Bazadaise",
  "Beef Freisian",
  "Beefalo",
  "Beefmaker",
  "Beefmaster",
  "Begayt",
  "Belgian Blue",
  "Belgian Red",
  "Belgian Red Pied",
  "Belgian White-and-Red",
  "Belmont Red",
  "Belted Galloway",
  "Bernese",
  "Berrenda cattle",
  "Betizu",
  "Bianca Modenese",
  "Blaarkop",
  "Black Angus",
  "Black Baldy",
  "Black Hereford",
  "Blanca Cacereña",
  "Blanco Orejinegro BON",
  "Blonde d'Aquitaine",
  "Blue Albion",
  "Blue Grey",
  "Bohuskulla",
  "Bonsmara",
  "Boran",
  "Boškarin",
  "Braford",
  "Brahman",
  "Brahmousin",
  "Brangus",
  "Braunvieh",
  "Brava",
  "British White",
  "British Friesian",
  "Brown Carpathian",
  "Brown Caucasian",
  "Brown Swiss",
  "Bue Lingo",
  "Burlina",
  "Buša cattle",
  "Butana cattle",
  "Bushuyev",
  "Cedit",
  "Breed",
  "Cachena",
  "Caldelana",
  "Camargue",
  "Campbell Island cattle",
  "Canadian Speckle Park",
  "Canadienne",
  "Canaria",
  "Canchim",
  "Caracu",
  "Cárdena Andaluza",
  "Carinthian Blondvieh",
  "Carora",
  "Charbray",
  "Charolais",
  "Chateaubriand",
  "Chiangus",
  "Chianina",
  "Chillingham cattle",
  "Chinese Black Pied",
  "Cholistani",
  "Coloursided White Back",
  "Commercial",
  "Corriente",
  "Corsican cattle",
  "Costeño con Cuernos",
  "Crioulo Lageano",
  "Dedit",
  "Breed",
  "Dajal",
  "Dangi cattle",
  "Danish Black-Pied",
  "Danish Jersey",
  "Danish Red",
  "Deep Red cattle",
  "Deoni",
  "Devon",
  "Dexter cattle",
  "Dhanni",
  "Doayo cattle",
  "Doela",
  "Drakensberger",
  "Dølafe",
  "Droughtmaster",
  "Dulong'",
  "Dutch Belted",
  "Dutch Friesian",
  "Dwarf Lulu",
  "Eedit",
  "Breed",
  "East Anatolian Red",
  "Eastern Finncattle",
  "Eastern Red Polled",
  "Enderby Island cattle",
  "English Longhorn",
  "Ennstaler Bergscheck",
  "Estonian Holstein",
  "Estonian Native",
  "Estonian Red cattle",
  "Évolène cattle",
  "Fedit",
  "Breed",
  "Fēng Cattle",
  "Finnish Ayrshire",
  "Finncattle",
  "Finnish Holstein-Friesian",
  "Fjäll",
  "Fleckvieh",
  "Florida Cracker cattle",
  "Fogera",
  "French Simmental",
  "Fribourgeoise",
  "Friesian Red and White",
  "Fulani Sudanese",
  "Gedit",
  "Breed",
  "Galician Blond",
  "Galloway cattle",
  "Gangatiri",
  "Gaolao",
  "Garvonesa",
  "Gascon cattle",
  "Gelbvieh",
  "Georgian Mountain cattle",
  "German Angus",
  "German Black Pied cattle",
  "German Black Pied Dairy",
  "German Red Pied",
  "Gir",
  "Glan cattle",
  "Gloucester",
  "Gobra",
  "Greek Shorthorn",
  "Greek Steppe",
  "Greyman cattle",
  "Gudali",
  "Guernsey cattle",
  "Guzerá",
  "Hedit",
  "Breed",
  "Hallikar4",
  "Hanwoo",
  "Hariana cattle",
  "Hartón del Valle",
  "Harzer Rotvieh",
  "Hays Converter",
  "Heck cattle",
  "Hereford",
  "Herens",
  "Hybridmaster",
  "Highland cattle",
  "Hinterwald",
  "Holando-Argentino",
  "Holstein Friesian cattle",
  "Horro",
  "Huáng Cattle",
  "Hungarian Grey",
  "Iedit",
  "Breed",
  "Iberian cattle",
  "Icelandic",
  "Illawarra cattle",
  "Improved Red and White",
  "Indo-Brazilian",
  "Irish Moiled",
  "Israeli Holstein",
  "Israeli Red",
  "Istoben cattle",
  "Istrian cattle",
  "Jedit",
  "Breed",
  "Jamaica Black",
  "Jamaica Hope",
  "Jamaica Red",
  "Japanese Brown",
  "Jarmelista",
  "Javari cattle",
  "Jersey cattle",
  "Jutland cattle",
  "Kedit",
  "Breed",
  "Kabin Buri cattle",
  "Kalmyk cattle",
  "Kangayam",
  "Kankrej",
  "Kamphaeng Saen cattle",
  "Karan Swiss",
  "Kasaragod Dwarf cattle",
  "Kathiawadi",
  "Kazakh Whiteheaded",
  "Kenana cattle",
  "Kenkatha cattle",
  "Kerry cattle",
  "Kherigarh",
  "Khillari cattle",
  "Kholomogory",
  "Korat Wagyu",
  "Kostroma cattle",
  "Krishna Valley cattle",
  "Kuri",
  "Kurgan cattle",
  "Ledit",
  "Breed",
  "La Reina cattle",
  "Lakenvelder cattle",
  "Lampurger",
  "Latvian Blue",
  "Latvian Brown",
  "Latvian Danish Red",
  "Lebedyn",
  "Levantina",
  "Limia cattle",
  "Limousin",
  "Limpurger",
  "Lincoln Red",
  "Lineback",
  "Lithuanian Black-and-White",
  "Lithuanian Light Grey",
  "Lithuanian Red",
  "Lithuanian White-Backed",
  "Lohani cattle",
  "Lourdais",
  "Lucerna cattle",
  "Luing",
  "Medit",
  "Breed",
  "Madagascar Zebu",
  "Madura",
  "Maine-Anjou",
  "Malnad Gidda",
  "Malvi",
  "Mandalong Special",
  "Mantequera Leonesa",
  "Maramureş Brown",
  "Marchigiana",
  "Maremmana",
  "Marinhoa",
  "Maronesa",
  "Masai",
  "Mashona",
  "Menorquina",
  "Mertolenga",
  "Meuse-Rhine-Issel",
  "Mewati",
  "Milking Shorthorn",
  "Minhota",
  "Mirandesa",
  "Mirkadim",
  "Mocăniţă",
  "Mollie",
  "Monchina",
  "Mongolian",
  "Montbéliarde",
  "Morucha",
  "Muturu",
  "Murboden",
  "Murnau-Werdenfels",
  "Murray Grey",
  "Nedit",
  "Breed",
  "Nagori",
  "N'Dama",
  "Negra Andaluza",
  "Nelore",
  "Nguni",
  "Nimari",
  "Normande",
  "North Bengal Grey",
  "Northern Finncattle",
  "Northern Shorthorn",
  "Norwegian Red",
  "Oedit]",
  "Breed",
  "Ongole",
  "Original Simmental",
  "Pedit",
  "Breed",
  "Pajuna",
  "Palmera",
  "Pantaneiro",
  "Parda Alpina",
  "Parthenaise",
  "Pasiega",
  "Pembroke",
  "Philippine Native",
  "Pie Rouge des Plaines",
  "Piedmontese cattle",
  "Pineywoods",
  "Pinzgauer",
  "Pirenaica",
  "Podolac",
  "Podolica",
  "Polish Black-and-White",
  "Polish Red",
  "Polled Hereford",
  "Poll Shorthorn",
  "Polled Shorthorn",
  "Ponwar",
  "Preta",
  "Punganur",
  "Pulikulam",
  "Pustertaler Sprinzen",
  "Qedit",
  "Breed",
  "Qinchaun",
  "Queensland Miniature Boran",
  "Redit",
  "Breed",
  "Ramo Grande",
  "Randall",
  "Raramuri Criollo",
  "Rathi",
  "Rätisches Grauvieh",
  "Raya",
  "Red Angus",
  "Red Brangus",
  "Red Chittagong",
  "Red Fulani",
  "Red Gorbatov",
  "Red Holstein",
  "Red Kandhari",
  "Red Mingrelian",
  "Red Poll",
  "Red Polled Østland",
  "Red Sindhi",
  "Retinta",
  "Riggit Galloway",
  "Ringamåla",
  "Rohjan",
  "Romagnola",
  "Romanian Bălţata",
  "Romanian Steppe Gray",
  "Romosinuano",
  "Russian Black Pied",
  "RX3",
  "Sedit",
  "Breed",
  "Sahiwal",
  "Salers",
  "Salorn",
  "Sanga",
  "Sanhe",
  "Santa Cruz",
  "Santa Gertrudis",
  "Sayaguesa",
  "Schwyz",
  "Selembu",
  "Senepol",
  "Serbian Pied",
  "Serbian Steppe",
  "Sheko",
  "Shetland",
  "Shorthorn",
  "Siboney de Cuba",
  "Simbrah",
  "Simford",
  "Simmental",
  "Siri",
  "South Devon",
  "Spanish Fighting Bull",
  "Speckle Park",
  "Square Meater",
  "Sussex",
  "Swedish Friesian",
  "Swedish Polled",
  "Swedish Red Pied",
  "Swedish Red Polled",
  "Swedish Red-and-White",
  "Tedit",
  "Breed",
  "Tabapuã",
  "Tarentaise",
  "Tasmanian Grey",
  "Tauros",
  "Telemark",
  "Texas Longhorn",
  "Texon",
  "Thai Black",
  "Thai Fighting Bull",
  "Thai Friesian",
  "Thai Milking Zebu",
  "Tharparkar",
  "Tswana",
  "Tudanca",
  "Tuli",
  "Tulim",
  "Turkish Grey Steppe",
  "Tux-Zillertal",
  "Tyrol Grey",
  "Uedit",
  "Breed",
  "Umblachery",
  "Ukrainian Grey",
  "Vedit",
  "Breed",
  "Valdostana Castana",
  "Valdostana Pezzata Nera",
  "Valdostana Pezzata Rossa",
  "Väneko",
  "Vaynol",
  "Vechur8",
  "Vestland Fjord",
  "Vestland Red Polled",
  "Vianesa",
  "Volinian Beef",
  "Vorderwald",
  "Vosgienne",
  "Wedit",
  "Breed",
  "Wagyu",
  "Waguli",
  "Wangus",
  "Welsh Black",
  "Western Finncattle",
  "White Cáceres",
  "White Fulani",
  "White Lamphun",
  "White Park",
  "Whitebred Shorthorn",
  "Xedit",
  "Breed",
  "Xingjiang Brown",
  "Yedit",
  "Breed",
  "Yakutian",
  "Yanbian",
  "Yanhuang",
  "Yurino",
  "Zedit",
  "Breed",
  "Żubroń",
  "Zebu",
];
